<template>
  <div class="card dashboard-chart-card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center flex-wrap gap-2">
        <div class="me-auto">
          <h6 class="mb-0">Ventas formalizadas por mes</h6>
          <p class="text-sm text-secondary mb-0">Total de ventas formalizadas agrupadas por mes</p>
        </div>
        <select
          v-model="selectedYear"
          class="form-select form-select-sm"
          style="width: auto; min-width: 110px;"
          @change="loadChartData"
        >
          <option v-for="year in yearOptions" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
    </div>
    <div class="card-body p-3">
      <div class="chart-wrap">
        <canvas ref="chartCanvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'RemissionsMonthlyChart',
  data() {
    const currentYear = new Date().getFullYear();
    return {
      selectedYear: currentYear,
      yearOptions: Array.from({ length: 6 }, (_, i) => currentYear - i),
      chart: null,
    };
  },
  methods: {
    formatMoney(value) {
      return parseFloat(value ?? 0).toLocaleString('es-ES', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    destroyChart() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
    },
    renderChart(labels, totals, counts) {
      this.destroyChart();
      const canvas = this.$refs.chartCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Total ventas',
              data: totals,
              backgroundColor: 'rgba(94, 114, 228, 0.85)',
              borderColor: 'rgba(94, 114, 228, 1)',
              borderWidth: 1,
              borderRadius: 4,
              maxBarThickness: 42,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const index = context.dataIndex;
                  const total = context.parsed.y ?? 0;
                  const count = counts[index] ?? 0;
                  return [
                    `Total: $${this.formatMoney(total)}`,
                    `Ventas: ${count}`,
                  ];
                },
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => `$${this.formatMoney(value)}`,
              },
              grid: {
                drawBorder: false,
              },
            },
            x: {
              grid: {
                display: false,
              },
            },
          },
        },
      });
    },
    async loadChartData() {
      try {
        const response = await this.$store.dispatch('analitycs/getYear', this.selectedYear);
        const data = response?.data ?? {};
        this.renderChart(
          data.labels ?? [],
          data.totals ?? [],
          data.counts ?? []
        );
      } catch (error) {
        console.error('Error loading remissions chart:', error);
        this.renderChart(
          ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          Array(12).fill(0),
          Array(12).fill(0)
        );
      }
    },
  },
  mounted() {
    this.loadChartData();
  },
  beforeUnmount() {
    this.destroyChart();
  },
};
</script>

<style scoped>
.chart-wrap {
  position: relative;
  height: 320px;
}
</style>
